import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { handlePostAuth } from '@/features/auth/utils/handlePostAuth';
import { STORAGE_KEYS } from '@/utils/constants';
import type { AuthResponse } from '@/types';
import { AUTH_INTENT_GUIDE, authPhoneUrl, type AuthIntent } from '../constants';
import { OTPVerifyForm } from '../components/OTPVerifyForm';

function readPersistedIntent(stateIntent?: AuthIntent): AuthIntent | undefined {
  if (stateIntent === AUTH_INTENT_GUIDE) return AUTH_INTENT_GUIDE;
  const stored = sessionStorage.getItem(STORAGE_KEYS.AUTH_INTENT);
  return stored === AUTH_INTENT_GUIDE ? AUTH_INTENT_GUIDE : undefined;
}

export function OTPVerifyPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setAuth, setMe } = useAuth();

  const state = location.state as { phone?: string; from?: string; intent?: AuthIntent };
  const phone = state?.phone || localStorage.getItem(STORAGE_KEYS.OTP_PHONE) || '';
  const from = state?.from;
  const intent = readPersistedIntent(state?.intent);

  useEffect(() => {
    if (!phone) {
      navigate(authPhoneUrl(intent), { replace: true, state: from ? { from } : undefined });
    }
  }, [phone, navigate, intent, from]);

  const handleSuccess = async (data: AuthResponse) => {
    setAuth(data);
    if (data.requiresProfileSetup) {
      // TravelerProfileGate (AuthLayout) will prompt; stay put until complete.
      return;
    }
    const route = await handlePostAuth(data, { intent, from, setMe });
    sessionStorage.removeItem(STORAGE_KEYS.AUTH_INTENT);
    navigate(route, { replace: true });
  };

  const handleBack = () => {
    navigate(authPhoneUrl(intent), { state: from ? { from } : undefined });
  };

  return <OTPVerifyForm phone={phone} intent={intent} from={from} onSuccess={handleSuccess} onBack={handleBack} />;
}
